import { z } from "zod";

// ─── Unassigned bank transaction (used in assign-payment modal) ───────────────

export const UnassignedTransactionSchema = z.object({
  id: z.string().uuid(),
  booking_date: z.string().date(),
  amount: z.string(),
  type: z.enum(["incoming", "outgoing"]),
  description: z.string(),
  counterparty: z.string().nullable(),
  nip: z.string().nullable(),
  source: z.enum(["bank_transaction", "non_invoice_transfer"]).default("bank_transaction"),
});
export type UnassignedTransaction = z.infer<typeof UnassignedTransactionSchema>;

export const UnassignedTransactionsResponseSchema = z.object({
  transactions: z.array(UnassignedTransactionSchema),
  total: z.number().int(),
});
export type UnassignedTransactionsResponse = z.infer<typeof UnassignedTransactionsResponseSchema>;

// ─── Assign payment request / response ───────────────────────────────────────

export const AssignPaymentRequestSchema = z.object({
  transaction_id: z.string().uuid(),
});
export type AssignPaymentRequest = z.infer<typeof AssignPaymentRequestSchema>;

export const AssignPaymentResponseSchema = z.object({
  invoice_id: z.string().uuid(),
  transaction_id: z.string().uuid(),
  payment_date: z.string().date(),
  payment_source: z.literal("manual"),
});
export type AssignPaymentResponse = z.infer<typeof AssignPaymentResponseSchema>;

// ─── Mark-paid (without transaction) response ────────────────────────────────

export const MarkInvoicePaidResponseSchema = z.object({
  invoice_id: z.string().uuid(),
  payment_date: z.string().date(),
  payment_source: z.literal("manual"),
});
export type MarkInvoicePaidResponse = z.infer<typeof MarkInvoicePaidResponseSchema>;

// ─── Unassign payment response ────────────────────────────────────────────────

export const UnassignPaymentResponseSchema = z.object({
  invoice_id: z.string().uuid(),
});
export type UnassignPaymentResponse = z.infer<typeof UnassignPaymentResponseSchema>;
